/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {tryDecodeUriComponent_} from './url-try-decode-uri-component';

const regex = /(?:^[#?]?|&)([^=&]+)(?:=([^&]*))?/g;

/**
 * Parses the query string of an URL. This method returns a simple key/value
 * map. If there are duplicate keys the latest value is returned.
 *
 * DO NOT import the function from this file. Instead, import parseQueryString
 * from `src/url.js`.
 *
 * @param {string} queryString
 * @return {!JsonObject}
 */
export function parseQueryString_(queryString) {
  const params = /** @type {!JsonObject} */ (Object.create(null));
  if (!queryString) {
    return params;
  }

  let match;
  while ((match = regex.exec(queryString))) {
    const name = tryDecodeUriComponent_(match[1], match[1]);
    const value = match[2]
      ? tryDecodeUriComponent_(match[2].replace(/\+/g, ' '), match[2])
      : '';
    params[name] = value;
  }
  return params;
}
